import { render, staticRenderFns } from "./detailItem.vue?vue&type=template&id=6b6ed22d&scoped=true"
import script from "./detailItem.vue?vue&type=script&lang=js"
export * from "./detailItem.vue?vue&type=script&lang=js"
import style0 from "./detailItem.vue?vue&type=style&index=0&id=6b6ed22d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ed22d",
  null
  
)

export default component.exports